import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { CloseOfferButton } from './close-offer-button';

type Props = {
  title: React.ReactElement;
  close: () => void;
  dismissable?: boolean;
};

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
`;

export const OfferTitleMobile = forwardRef<HTMLDivElement, Props>(
  ({ title, close, dismissable = true }, ref) => (
    <TitleWrapper ref={ref}>
      {title}
      {dismissable && (
        <CloseOfferButton onClick={close} css={{ marginTop: 10 }} />
      )}
    </TitleWrapper>
  )
);
